<template>
  <div class="holiday-main-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
        <template #right>
          <span class="tit-right">
            <img class="left-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
          </span>
        </template>
      </van-nav-bar>
    </div>

    <div class="holiday-con" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <div class="holiday-head">
        <img class="head-img-back" src="./images/main-bg.png" />

        <div class="head-img" :style="{ 'margin-top': `${barHeight + 26}px` }">
          <img :src="getMatchTitle('tit-bg-', $i18n.locale)" />
        </div>

        <div class="deal-line">
          <div class="timer">
            <img src="./images/clock.png" />
            <span class="time-num">
              <span>{{ countdownResult.days }}</span>
              <i>{{ $t('lang.commonM.k297') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.hours }}</span>
              <i>{{ $t('lang.commonM.k364') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.minutes }}</span>
              <i>{{ $t('lang.commonM.k365') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.seconds }}</span>
              <i>{{ $t('lang.commonM.k366') }}</i>
            </span>
          </div>
        </div>
      </div>

      <div class="main-con">
        <div class="part-block" style="margin-top: 0">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k208') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k419') }}</div>

          <div v-if="actInfo" class="points-rank">
            <div class="pr-item">
              <div>{{ $t('lang.commonM.k221') }}</div>
              <div v-if="actInfo">{{ actInfo.score || 0 }}</div>
            </div>
            <div class="pr-gap"></div>
            <div class="pr-item">
              <div>{{ $t('lang.commonM.k222') }}</div>
              <div>{{ actInfo.rank || '--' }}</div>
            </div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k218') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k420') }}</div>
          <div class="holiday-reward">
            <div class="holiday-item">
              <div class="reward-num">No.1</div>
              <div class="reward-coins">
                {{ boardData.num1Reward }}
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
            <div class="holiday-item">
              <div class="reward-num">No.2</div>
              <div class="reward-coins">
                {{ boardData.num2Reward }}
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
            <div class="holiday-item">
              <div class="reward-num">No.3</div>
              <div class="reward-coins">
                {{ boardData.num3Reward }}
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
            <div class="holiday-item">
              <div class="reward-num">No.4-10</div>
              <div class="reward-coins">
                {{ boardData.num4Reward }}
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
          </div>

          <div class="btn-block">
            <div class="holiday-btn" @click="handleToRank">{{ $t('lang.commonM.k220') }}</div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k435') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k436') }}</div>

          <!-- task-1 -->
          <!-- prettier-ignore -->
          <div v-if="actInfo && actInfo.signTask" class="task-item">
            <span class="task-item-tit">
              {{ $t('lang.commonM.k265') }}&nbsp;
              <span>{{ actInfo.signTask.proc }}</span>/<i>{{ actInfo.signTask.target }}</i>
            </span>
            <div class="task-item-reward">
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x1</div>
              </div>
            </div>
            <div v-if="actInfo.signTask.state === 0" class="task-item-btn blue" @click="handleSign">{{ $t('lang.commonM.k293') }}</div>
            <div v-if="actInfo.signTask.state === 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>

          <!-- task-2 -->
          <div v-if="actInfo && actInfo.call1Task" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">
              <MyPLabel :str="$t('lang.commonM.k437')" :numsOption="[{value: 1}]" />&nbsp;
              <span>{{ actInfo.call1Task.proc }}</span>/<i>{{ actInfo.call1Task.target }}</i>
            </span>
            <div class="task-item-reward">
              <!-- 头像框 -->
              <div v-if="packageName !== 'echo'" class="task-item-gift">
                <div class="item-gift-img"><img src="./images/avatar-bar.png" /></div>
                <div class="item-gift-num">x1</div>
              </div>

              <div v-if="packageName !== 'echo'" class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x1</div>
              </div>

              <div class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('super-chat-pass')" /></div>
                <div class="item-gift-num">x1</div>
              </div>
            </div>

            <div v-if="actInfo.call1Task.state === 0" class="task-item-btn blue" @click="handleToChatList">
              <img src="./images/btn-arrow.png" />
            </div>
            <div v-if="actInfo.call1Task.state === 1" class="task-item-btn blue" @click="handleClaim(1)">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="actInfo.call1Task.state === 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>

          <!-- task-3 -->
          <div v-if="actInfo && actInfo.call5Task" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">
              <MyPLabel :str="$t('lang.commonM.k437')" :numsOption="[{value: 5}]" />&nbsp;
              <span>{{ actInfo.call5Task.proc }}</span>/<i>{{ actInfo.call5Task.target }}</i>
            </span>
            <div class="task-item-reward">
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('coupon')" /></div>
                <div class="item-gift-num">x1</div>
              </div>

              <div class="task-item-gap"></div>

              <!-- 头像框 -->
              <div v-if="packageName !== 'echo'" class="task-item-gift">
                <div class="item-gift-img"><img src="./images/avatar-bar.png" /></div>
                <div class="item-gift-num">x3</div>
              </div>

              <div v-if="packageName !== 'echo'" class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x3</div>
              </div>

              <div class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('super-chat-pass')" /></div>
                <div class="item-gift-num">x3</div>
              </div>
            </div>

            <div v-if="actInfo.call5Task.state === 0" class="task-item-btn blue" @click="handleToChatList">
              <img src="./images/btn-arrow.png" />
            </div>
            <div v-if="actInfo.call5Task.state === 1" class="task-item-btn blue" @click="handleClaim(5)">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="actInfo.call5Task.state === 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>

          <!-- task-4 -->
          <div v-if="actInfo && actInfo.call10Task" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">
              <MyPLabel :str="$t('lang.commonM.k437')" :numsOption="[{value: 10}]" />&nbsp;
              <span>{{ actInfo.call10Task.proc }}</span>/<i>{{ actInfo.call10Task.target }}</i>
            </span>
            <div class="task-item-reward">
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('coupon')" /></div>
                <div class="item-gift-num">x2</div>
              </div>

              <div class="task-item-gap"></div>

              <!-- 头像框 -->
              <div v-if="packageName !== 'echo'" class="task-item-gift">
                <div class="item-gift-img"><img src="./images/avatar-bar.png" /></div>
                <div class="item-gift-num">x5</div>
              </div>

              <div v-if="packageName !== 'echo'" class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x5</div>
              </div>

              <div class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('super-chat-pass')" /></div>
                <div class="item-gift-num">x5</div>
              </div>
            </div>

            <div v-if="actInfo.call10Task.state === 0" class="task-item-btn blue" @click="handleToChatList">
              <img src="./images/btn-arrow.png" />
            </div>
            <div v-if="actInfo.call10Task.state === 1" class="task-item-btn blue" @click="handleClaim(10)">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="actInfo.call10Task.state === 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>
        </div>

        <div v-if="showSuccess" class="act-mask">
          <div class="dia-bg" :class="[showSuccess === 3 || showSuccess === 4 ? 'dia-bg2' : 'dia-bg1']">
            <div class="con-block">
              <div class="gifts-tit">
                <span>{{ $t('lang.commonM.k147') }}!</span>
              </div>
              <div v-if="showSuccess === 1" class="gifts">
                <div>
                  <div class="img-wrap img-big">
                    <img :src="getMatchImg('video-pass')" alt="" />
                  </div>
                  <div class="rewards-name">{{ $t('lang.commonM.k087') }}</div>
                  <div class="rewards-count">x1</div>
                </div>
              </div>

              <div v-if="showSuccess === 2" class="gifts">
                <div v-if="packageName !== 'echo'">
                  <div class="img-wrap">
                    <img src="./images/avatar-bar.png" alt="" />
                  </div>
                  <div class="rewards-name">{{ $t('lang.commonM.k445') }}</div>
                  <div class="rewards-count">x1</div>
                </div>

                <div>
                  <div class="img-wrap">
                    <img :src="getMatchImg('video-pass')" alt="" />
                  </div>
                  <div class="rewards-name">{{ $t('lang.commonM.k087') }}</div>
                  <div class="rewards-count">x1</div>
                </div>

                <div>
                  <div class="img-wrap">
                    <img :src="getMatchImg('super-chat-pass')" alt="" />
                  </div>
                  <div class="rewards-name">{{ $t('lang.commonM.k088') }}</div>
                  <div class="rewards-count">x1</div>
                </div>
              </div>

              <template v-if="showSuccess === 3">
                <div class="gifts tworow" style="justify-content: space-around; margin-bottom: 0">
                  <div v-if="packageName !== 'echo'">
                    <div class="img-wrap">
                      <img src="./images/avatar-bar.png" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.commonM.k445') }}</div>
                    <div class="rewards-count">x3</div>
                  </div>

                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('super-chat-pass')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.commonM.k088') }}</div>
                    <div class="rewards-count">x3</div>
                  </div>
                </div>

                <div class="gifts tworow" style="justify-content: space-around">
                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('video-pass')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.commonM.k087') }}</div>
                    <div class="rewards-count">x3</div>
                  </div>

                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('coupon')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.giftSign.coupon') }}</div>
                    <div class="rewards-count">x1</div>
                  </div>
                </div>
              </template>

              <template v-if="showSuccess === 4">
                <div class="gifts tworow" style="justify-content: space-around; margin-bottom: 0">
                  <div v-if="packageName !== 'echo'">
                    <div class="img-wrap">
                      <img src="./images/avatar-bar.png" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.commonM.k445') }}</div>
                    <div class="rewards-count">x5</div>
                  </div>

                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('super-chat-pass')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.commonM.k088') }}</div>
                    <div class="rewards-count">x5</div>
                  </div>
                </div>

                <div class="gifts tworow" style="justify-content: space-around">
                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('video-pass')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.commonM.k087') }}</div>
                    <div class="rewards-count">x5</div>
                  </div>

                  <div>
                    <div class="img-wrap">
                      <img :src="getMatchImg('coupon')" alt="" />
                    </div>
                    <div class="rewards-name">{{ $t('lang.giftSign.coupon') }}</div>
                    <div class="rewards-count">x2</div>
                  </div>
                </div>
              </template>

              <div class="gifts-confirm" @click="showSuccess = 0">
                <div>{{ $t('lang.ok') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfo, holidayDaySign, holidayDayClaim } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'
import CountDownClass from '@/utils/count-down.js'

// en
import vavaTitBgEn from './images/vava/bg-en.png'
import echoTitBgEn from './images/echo/bg-en.png'
import joychatTitBgEn from './images/joychat/bg-en.png'
import kikoTitBgEn from './images/kiko/bg-en.png'

// es
import vavaTitBgEs from './images/vava/bg-es.png'
import echoTitBgEs from './images/echo/bg-es.png'
import joychatTitBgEs from './images/joychat/bg-es.png'
import kikoTitBgEs from './images/kiko/bg-es.png'

// pt
import vavaTitBgPt from './images/vava/bg-pt.png'
import echoTitBgPt from './images/echo/bg-pt.png'
import joychatTitBgPt from './images/joychat/bg-pt.png'
import kikoTitBgPt from './images/kiko/bg-pt.png'

// tr
import vavaTitBgTr from './images/vava/bg-tr.png'
import echoTitBgTr from './images/echo/bg-tr.png'
import joychatTitBgTr from './images/joychat/bg-tr.png'
import kikoTitBgTr from './images/kiko/bg-tr.png'

// ar
import vavaTitBgAr from './images/vava/bg-ar.png'
import echoTitBgAr from './images/echo/bg-ar.png'
import joychatTitBgAr from './images/joychat/bg-ar.png'
import kikoTitBgAr from './images/kiko/bg-ar.png'

// fr
import vavaTitBgFr from './images/vava/bg-fr.png'
import echoTitBgFr from './images/echo/bg-fr.png'
import joychatTitBgFr from './images/joychat/bg-fr.png'
import kikoTitBgFr from './images/kiko/bg-fr.png'

// id
import vavaTitBgId from './images/vava/bg-id.png'
import echoTitBgId from './images/echo/bg-id.png'
import joychatTitBgId from './images/joychat/bg-id.png'
import kikoTitBgId from './images/kiko/bg-id.png'

const imgsMap = {
  'tit-bg-en': {
    vava: vavaTitBgEn,
    echo: echoTitBgEn,
    joychat: joychatTitBgEn,
    kiko: kikoTitBgEn
  },
  'tit-bg-es': {
    vava: vavaTitBgEs,
    echo: echoTitBgEs,
    joychat: joychatTitBgEs,
    kiko: kikoTitBgEs
  },
  'tit-bg-pt': {
    vava: vavaTitBgPt,
    echo: echoTitBgPt,
    joychat: joychatTitBgPt,
    kiko: kikoTitBgPt
  },
  'tit-bg-tr': {
    vava: vavaTitBgTr,
    echo: echoTitBgTr,
    joychat: joychatTitBgTr,
    kiko: kikoTitBgTr
  },
  'tit-bg-fr': {
    vava: vavaTitBgFr,
    echo: echoTitBgFr,
    joychat: joychatTitBgFr,
    kiko: kikoTitBgFr
  },
  'tit-bg-ar': {
    vava: vavaTitBgAr,
    echo: echoTitBgAr,
    joychat: joychatTitBgAr,
    kiko: kikoTitBgAr
  },
  'tit-bg-id': {
    vava: vavaTitBgId,
    echo: echoTitBgId,
    joychat: joychatTitBgId,
    kiko: kikoTitBgId
  }
}

export default {
  mixins: [countDown],
  data() {
    return {
      actInfo: null,
      packageName: '',
      boardData: {
        num1Reward: 1000,
        num2Reward: 700,
        num3Reward: 500,
        num4Reward: 80
      },
      leftClassObj: null,
      showSuccess: 0,
      loading: false
    }
  },
  methods: {
    getMatchTitle(imgnamePre, lang) {
      let imgname = imgnamePre + lang
      if (!imgsMap[imgname]) {
        imgname = imgnamePre + 'en'
      }
      if (imgsMap[imgname]) {
        // 按包名判断
        const appName = this.getAppName()
        if (this.appNameFlag('vava', appName)) {
          return imgsMap[imgname]['vava']
        }
        if (this.appNameFlag('echo', appName)) {
          return imgsMap[imgname]['echo']
        }
        if (this.appNameFlag('joychat', appName)) {
          return imgsMap[imgname]['joychat']
        }
        if (this.appNameFlag('kiko', appName)) {
          return imgsMap[imgname]['kiko']
        }
      }
      return ''
    },
    handleToRule() {
      this.$router.push({ path: '/christmas-rules-male', query: { from: 'christmas-main-male' } })
    },
    handleToRank() {
      this.$router.push({ path: '/christmas-rank-male', query: { from: 'christmas-main-male' } })
    },
    handleReplaceToRank() {
      this.$router.replace({ path: '/christmas-rank-male' })
    },
    handleSign() {
      if (this.loading) {
        return
      }
      this.loading = true
      holidayDaySign()
        .then((resData) => {
          if (resData && resData.data) {
            this.showSuccess = 1
            this.fetchData()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleToChatList() {
      this.appAction('open_session_page')
    },
    handleClaim(arg) {
      if (this.loading) {
        return
      }
      this.loading = true

      const idMap = {
        1: 2,
        5: 3,
        10: 4
      }
      holidayDayClaim(arg)
        .then((resData) => {
          if (resData && !resData.error) {
            this.showSuccess = idMap[arg]
            this.fetchData()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchData() {
      holidayActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          this.actInfo = resData || null

          if (!this.actInfo) return

          if (this.actInfo.countdown <= 0) {
            this.handleReplaceToRank()
            return
          }

          // 初始化倒计时
          if (this.actInfo.endTimestamp) {
            this.initCountDown(this.actInfo.endTimestamp, true, true)
          }

          if (this.actInfo.dailyCountdown) {
            this.leftClassObj = new CountDownClass()
            this.leftClassObj.initCountDown(this.actInfo.dailyCountdown, false)
          }
        }
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
.holiday-main-root {
  width: 100%;
  min-height: 100vh;

  .custom-nav-block {
    background: url(./images/main-bg.png) top left / 100% auto no-repeat;
  }

  .holiday-con {
    .holiday-head {
      width: 100%;
      min-height: 370px;
      font-size: 0;
      position: relative;
      .head-img-back {
        width: 100%;
      }
      .head-img {
        position: absolute;
        top: 0;
        z-index: 9;
        width: 100%;
        img {
          display: block;
          width: 100%;
        }
      }

      .deal-line {
        position: absolute;
        left: 50%;
        bottom: 53px;
        z-index: 9;
        min-width: 223px;
        height: 40px;
        padding: 0 24px;
        transform: translateX(-50%);

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 12px;
        background: rgba(0, 32, 107, 0.7);
        backdrop-filter: blur(30px);

        .timer {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 32px;
            height: 32px;
            margin: 0 3px;
          }
          > span {
            color: #fff;
            font-family: 'TikTokSans-Regular';
            font-size: 20px;
            font-style: normal;
            font-weight: bold;
            line-height: 22px;
            display: flex;
            align-items: flex-end;
            i {
              font-size: 16px;
              line-height: 18px;
            }
          }
          .stp {
            padding: 0 2px;
          }
          .time-num {
            span {
              width: 26px;
              text-align: center;
            }
          }
        }
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      padding-bottom: 79px;
      margin-top: -32px;
      background: url(./images/main-con.png) top left / 100% 100% no-repeat;

      .part-block {
        width: 355px;
        margin: 16px auto 0;
        padding-bottom: 24px;
        background: #f2f7fa;
        border-radius: 12px;
        .part-head {
          width: 355px;
          line-height: 42px;
          background: #0d6fc7;
          border-radius: 12px 12px 0px 0px;
          text-align: center;
          span {
            color: #fff;
            font-family: 'TikTokSans-Regular';
            font-size: 17px;
            font-weight: bold;
          }
        }
        .part-tips {
          width: 100%;
          padding: 16px;
          font-family: TikTokSans-Regular;
          font-size: 15px;
          color: #284188;
          line-height: 22px;
          font-weight: normal;
        }

        .points-rank {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 16px;
          .pr-item {
            flex: 1;
            height: 66px;
            padding: 10px;
            background: #c5e3ff;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            div:nth-child(1) {
              font-family: TikTokSans-Regular;
              font-weight: 400;
              font-size: 15px;
              color: #292d59;
              line-height: 20px;
            }
            div:nth-child(2) {
              font-family: TikTokSans-Regular;
              font-weight: bold;
              font-size: 20px;
              color: #292d59;
              line-height: 24px;
            }
          }
          .pr-gap {
            width: 40px;
          }
        }

        .holiday-reward {
          width: 100%;
          padding: 0 16px;
          min-height: 116px;
          margin: 0 auto;

          .holiday-item {
            font-family: TikTokSans-Regular;
            font-weight: 400;
            font-size: 15px;
            color: #292d59;
            line-height: 20px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            .reward-coins {
              display: flex;
              align-items: center;
              font-weight: bold;
              color: #292d59;
              .coins-icon {
                width: 16px;
                height: 16px;
                margin-left: 4px;
              }
            }
          }
        }

        .task-item {
          padding: 0 16px;
          margin-bottom: 20px;
          position: relative;
          .task-item-tit {
            color: #284188;
            font-family: 'TikTokSans-Regular';
            font-size: 15px;
            display: flex;
            align-items: center;
            span {
              color: #284188;
            }
            i {
              color: #a4a9bd;
            }
          }
          .task-item-reward {
            margin-top: 6px;
            display: flex;
            align-items: center;
            .task-item-gap {
              width: 10px;
            }
            .task-item-gift {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .item-gift-img {
                border-radius: 6px;
                width: 38px;
                height: 38px;
                background: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: 30px;
                }
              }
              .item-gift-num {
                margin-top: 4px;
                color: #292d59;
                font-family: 'TikTokSans-Regular';
                font-size: 12px;
                font-style: italic;
                font-weight: 700;
              }
            }
          }
          .task-item-btn {
            position: absolute;
            top: 50%;
            right: 16px;
            transform: translateY(-50%);
            text-align: center;
            font-family: 'TikTokSans-Regular';
            font-size: 16px;
            font-weight: 600;
            border-radius: 30px;
            min-width: 100px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 22px;
            }
          }
          .task-item-btn.blue {
            background: linear-gradient(92deg, #268afe 5.42%, #25aecb 94.93%);
            color: #ffffff;
            font-weight: 400;
          }
          .task-item-btn.yellow {
            background: #ffb625;
            color: #ffffff;
            font-weight: 400;
          }
          .task-item-btn.disable {
            background: #a4a9bd;
            color: #edeef2;
            font-weight: 400;
          }
        }
      }
      .task-block {
        padding: 0 16px;
        .part-tips-b {
          font-family: TikTokSans-Regular;
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          margin-top: 32px;
          text-align: left;
        }
        .part-task {
          margin-top: 13px;
          font-family: TikTokSans-Regular;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
        }
      }

      .btn-block {
        display: block;
        width: 100%;
        margin: 30px auto 8px;
        text-align: center;
        .holiday-btn {
          min-width: 275px;
          display: inline-block;
          padding: 10px 15px;
          border-radius: 30px;
          background: linear-gradient(92deg, #268afe 5.42%, #25aecb 94.93%);
          font-family: TikTokSans-Regular;
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
          line-height: 26px;
          text-align: center;
          &.btn-disable {
            opacity: 0.4;
          }
        }
      }
    }
  }
}

.act-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dia-bg {
    width: 325px;
    border-radius: 16px;

    .con-block {
      width: 325px;
      border-radius: 16px;
      padding: 35px 20px 30px;

      .gifts-tit {
        line-height: 20px;
        text-align: center;
        margin-bottom: 16px;

        span {
          color: #fafbff;
          text-align: center;
          font-family: 'TikTokSans-Regular';
          font-size: 20px;
          font-style: normal;
          font-weight: 900;
          line-height: normal;
        }
      }

      .gifts {
        width: 100%;
        padding: 12px 0;
        border-radius: 8px;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        & > div {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .img-wrap {
            width: 40px;
            height: 40px;
            padding: 5px;
            border-radius: 8px;
            border: 0.5px solid rgba(255, 255, 255, 0.5);
            background: rgba(18, 67, 174, 0.6);
            img {
              width: 100%;
            }
            &.img-big {
              width: 60px;
              height: 60px;
            }
          }
          .rewards-name {
            font-family: TikTokSans-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
            line-height: 22px;
            margin-top: 4px;
            text-align: center;
            opacity: 0.9;
          }
          .rewards-count {
            font-family: TikTokSans-Regular;
            font-weight: bold;
            font-size: 17px;
            color: #ffffff;
            line-height: 22px;
            font-style: italic;
            opacity: 0.9;
            margin-top: 2px;
          }
        }
      }

      .tworow {
        padding: 12px 26px;
      }

      .gifts-confirm {
        width: 255px;
        margin: 0 auto;
        margin-top: 28px;
        padding: 10px;
        border-radius: 30px;
        background: linear-gradient(92deg, #268afe 5.42%, #25aecb 94.93%);

        color: #fff;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px;
      }
    }
  }

  .dia-bg1 {
    background: url(./images/dialog-bg1.png) left top / 100% 100% no-repeat;
  }

  .dia-bg2 {
    background: url(./images/dialog-bg2.png) left top / 100% 100% no-repeat;
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .holiday-main-root .holiday-con .main-con .part-block .task-item .task-item-btn {
    right: unset;
    left: 16px;
  }
}
</style>
